<template>
  <div class="engineer-list-page">
    <mt-header fixed title="工程师列表" style="background:#3189FF;color:#ffffff;z-index:3;">
        <mt-button icon="back" slot="left" @click="goBack"></mt-button>
      <mt-button slot="right" @click="sortEngs">
          <span class="sort">
              排序
            <img src="../assets/images/Triangle@3x.png" class="trangle">
          </span>
      </mt-button>
    </mt-header>

    <div class="engModal" v-if="isShow" @touchmove.prevent>
      <ul class="typeList">
        <li :class="{'active':sortType==item.id}" v-for="item of sortTypes" :key="item.id" @click="selectSortType(item)">
          <span>{{item.name}}</span>
          <div class="img"></div>
        </li>
      </ul>
    </div>

    <div class="scroll-wrapper">
      <div class="scroll-content">
        <img class="banner_pic" src="https://tu.auntec.cn/app/gsx/eng_list_pic%403x.jpg">
        <ul class="engs"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="3">
            <li class="eng-item" v-for="(item,index) in engineers" :key="index" @click="goEngineer(item)">
                <div class="headurl">
                    <div v-if="item.status=='1'" class="tag" style="background:#25E266"></div>
                    <div v-if="item.status=='2'" class="tag" style="background:#EA4E3D"></div>
                    <div v-if="item.status=='4'" class="tag" style="background:#CCCCCC"></div>
                    <img :src="item.avatar_url">
                    <span v-if="item.status=='1'">在线</span>
                    <span v-if="item.status=='2'">忙碌</span>
                    <span v-if="item.status=='4'">不在线</span>
                </div>
                <ul class="engs-list">
                    <li>
                        <span>{{item.eng_name}}</span>
                        <span>从业{{item.career_years}}年</span>
                    </li>
                    <li>
                        <span>简介：</span>{{item.profile}}{{item.profile}}{{item.profile}}
                    </li>
                    <li>
                        <span>好评率：{{item.feedback_rate}}%</span>
                        <span>服务数：{{item.service_count}}</span>
                    </li>
                </ul>
            </li>
        </ul>
        <div class="end-line" v-if="isEnd">
          到达页面底部，双击标题栏返回页顶
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Popup,InfiniteScroll} from 'mint-ui';
export default {
    name:"purchase",//购买服务
     metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            engineers: [],
            sortTypes: [
              { id: 0, name: '默认排序', order_by: 'default', order_dir: '' },
              { id: 1, name: '从业时间最长', order_by: 'career_years', order_dir: 'desc' },
              { id: 2, name: '从业时间最短', order_by: 'career_years', order_dir: 'asc' },
              { id: 3, name: '好评率最高', order_by: 'feedback_rate', order_dir: 'desc' },
              { id: 4, name: '好评率最低', order_by: 'feedback_rate', order_dir: 'asc' },
              { id: 5, name: '服务数最多', order_by: 'service_count', order_dir: 'desc' },
              { id: 6, name: '服务数最少', order_by: 'service_count', order_dir: 'asc' }
            ],
            sortType: 0,
            isShow: false,
            order_by: 'default',
            order_dir: '',
            currentPage: 1,
            pageCount: 100000,
            isEnd: false,
            gid: ''
        }
    },
    methods:{
        goBack(){
          history.go(-1);
        },
        goEngineer(data){
          let onlineStatus
          if(data.status == "1"){
            onlineStatus = '在线'
          }else if(data.status == '2'){
            onlineStatus = '忙碌'
          }else if(data.status == '4'){
            onlineStatus = "不在线"
          }
          this.sa_m_check_engineer_detail(
            onlineStatus,
            data.eng_name,
            data.eng_no
          )
          if(this.gid){
            this.$router.push({name:'engineer',query:{eng_no:data.eng_no,gid:this.gid}})
          }else {
            this.$router.push({name:'engineer',query:{eng_no:data.eng_no}})
          }
          
        },
        selectSortType(data){
          this.sa_m_sort(data.order_by)
          this.engineers = []
          this.currentPage = 1
          this.sortType = data.id
          this.isShow = false
          let info = {
            page:this.currentPage,
            order_by: data.order_by,
            order_dir: data.order_dir
          }
            
          this.order_dir = data.order_dir
          this.order_by = data.order_by
          this.getEngineers('sort',info)
        },
        sortEngs(){
          this.isShow = !this.isShow
          if(this.isShow){
            this.sa_m_click_sort()
          }
        },
        loadMore(){
          if(this.currentPage < this.pageCount){
            this.isEnd = false
            this.currentPage++
            let info ={
              page: this.currentPage,
              order_by: this.order_by,
              order_dir: this.order_dir
            }
            this.getEngineers('load',info)
          }else {
            this.isEnd = true
          }
        },
        getEngineers(type,info){
          if(this.gid){
            info['gid'] = this.gid
          }
          this.$store.dispatch("getEngineers",info).then((res)=>{
            let result = res.data
            if(result.code == 0){
              this.pageCount = result.res._meta.pageCount
              if(type == 'load'){
                this.engineers = this.engineers.concat(result.res.items)
              }else {
                this.engineers = result.res.items
              }
            }
          })
        }
    },
    created(){
      this.gid = this.$route.query.gid
      let info = {
        page: this.currentPage,
        order_by: this.order_by,
        order_dir: this.order_dir
      }
      this.getEngineers('load',info)
    },
    mounted(){
    },
    
    components:{
    }

}
</script>

<style lang="scss" scoped="" type="text/css">
.combo_select{
  padding: 0.3rem 0.66667rem 0.3rem;
  border-bottom: 1px solid #e5e5e5;
}
  .combo_select h3{
    line-height: 1rem;
    font-size: 0.36rem;
  }

  .combo_select div {
    width: 100%;
    height: 1.1rem;
    line-height: 1.1rem;
    border: 1px solid #ccc;
    background: transparent;
    font-size: .48rem;
    color: #989898;
    border-radius: .10667rem;
    margin-bottom: .3rem;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    justify-content: space-around;
  }

  .combo_select .selected{
    background: #3189ff;
    border: 1px solid #3189ff;
    color: #fff;
  }

  .combo_select .selected .select_img{
    display: inline-block;
  }

  .combo_select .selected .no_select_img{
    display: none;
  }

  .combo_select div .select_img {
    display: none;
    width: 0.6rem;
  }

  .combo_select div .no_select_img {
    width: 0.6rem;
  }
  .combo_select div span {
    font-size: 0.36rem;
  }
  .purchase_btn_ser{
    height: 1.17333rem!important;
  }
  .purchase_btn_ser .fee{
    color: #717070;
    font-size: .37333rem;
    display: block;
    -ms-flex: 1;
    flex: 1;
    height: 1rem;
    line-height: 1rem;
    margin-left: .53333rem;
  }
  .purchase_btn_ser .fee .money{
    font-size: .4rem;
    color: #ff001f;
  }
  .purchase_btn_ser button{
    background: #3189ff;
    border: none;
    color: #fff;
    width: 4.26667rem;
    font-size: .48rem;
    height: 1.17333rem;
    cursor: pointer;
  }
  .module_description{
    white-space: pre-wrap;
    word-wrap: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/components/EngineerList.vue